import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';

export const useDeleteCustomer = () => {
  const queryClient = useQueryClient();

  const deleteCustomer = async (customerId: number) => {
    const response = await Axios.delete(
      `${DELETE_URL(customerId.toString()).deleteCustomer}`
    );
    return response.data;
  };

  return useMutation<void, AxiosError<BaseError>, number>(
    (customerId: number) => deleteCustomer(customerId),
    {
      onSuccess: (_, customerId) => {
        queryClient.invalidateQueries(['resellers', customerId]);
      },
      useErrorBoundary: false
    }
  );
};
